namespace Solovis.Reports.Parameters {

  export class AssetSelectionSetParameterControl extends Solovis.UI.BaseControl {
    public static hasNewRender = true;

    private _portalServices: Solovis.Portal.IPortalServices;

    public initialParameterValue;
    public currentAssetSelectionSet;

    public selectedAssetSelectionSetLabel;
    public selectAssetSelectionSetLink;
    public selectRef;

    constructor(options) {
      super(options);

      this._portalServices = options.portalServices;

      this.initialParameterValue = (typeof options.initialValue != "undefined") ? options.initialValue : null;
      this.currentAssetSelectionSet = this.initialParameterValue;
    }


    public static getDefaultSelectionSet(advancedMode = false) {
      return {
        assetSelectionSetMode: advancedMode ? "Advanced" : "Basic",
        blocks: [{ blockType: "Investment" }]
      };
    }

    public static preload(newValue, callback, portalServices: Solovis.Portal.IPortalServices): void {
      if (!portalServices) {
        portalServices = new Solovis.Portal.SitePortalServices();
      }

      if (newValue && (newValue.id || newValue.name)) {
        var loadOptions: any = { assetSelectionSet: {} };
        if (newValue.id)
          loadOptions.assetSelectionSet.id = newValue.id;
        if (newValue.name)
          loadOptions.assetSelectionSet.name = newValue.name;

        portalServices.reportDataLoader().loadDataSetAsync(
          "/Solovis/Metadata/ParameterLoad",
          loadOptions,
          function (response, success) {
            if (success) {
              var dataSet = response.result.dataSet;
              var assetSelectionSetData = dataSet.assetSelectionSet ? dataSet.assetSelectionSet : null;
              callback(assetSelectionSetData, true);
            }
            else {
              callback(null, false);
            }
          });
      }
      else {
        callback(null, true);
      }
    };

    public static shouldPreload(value): boolean {
      if (!value || ((value.id && value.name) || value.custom)) {
        // Already loaded.
        return false;
      }

      return true;
    }

    public static serializeParameterValue(value): any {
      if (value) {
        if (value.id) {
          return { id: value.id };
        }
        else if (value.custom) {
          return { custom: value.custom };
        }
      }

      return null;
    }

    public doInit() {
    }

    private async doRenderNew() {
      var self = this;

      const initial = (self.options as any).initialValue;
      await Solovis.UX.Utils.placeComponent("AssetSelectionSetParameterControl", this.container[0], {
        defaultValue: initial,
        onChange: (selectedItem) => {
          self.setParameterValue(selectedItem);
        },
        onOptionEdit: (selectedItem) => {
          self.setParameterValue(selectedItem);
          self._convertToAdHoc(true);
        },
        ref: (ref) => {
          self.selectRef = ref;
        },
      });
    }

    public slotRenderFunction(slotContainer) {
      const self = this;
      $("<a>")
        .html("<span>Ad-Hoc</span>")
        .css("color", "#1E5AB4")
        // closure
        .click(() => {
          //if it is already custom open the editor
          if ((self.currentAssetSelectionSet || {}).custom) {
            self._showAdHocEditor(self.currentAssetSelectionSet.custom);
          } else {
            /*
            self.selectRef.setValue({
              name: "(Ad-Hoc)",
              custom: AssetSelectionSetParameterControl.getDefaultSelectionSet(),
            });
            */
            self._showAdHocEditor(
              AssetSelectionSetParameterControl.getDefaultSelectionSet()
            );
          }
        })
        .appendTo(slotContainer);
    }

    public async doRender() {
      if (this.options.renderMode === 'modern') {
        this.doRenderNew();
      } else {
        this.doRenderClassic();
      }
    }

    public doRenderClassic() {
      var self = this;

      this.selectedAssetSelectionSetLabel = $("<a>").appendTo(this.container);
      Solovis.UI.PopupLinkPanel.onElementClick(this.selectedAssetSelectionSetLabel, function (e) {
        self._showSelectedSetContextMenu(e);
      });

      this.selectAssetSelectionSetLink = $("<a>").html("<span class='fa fa-pencil'></span>").appendTo(this.container);

      this.selectAssetSelectionSetLink.click(function () {
        self._toggleSelectorDialog(function (assetSelectionSet) {
          self._setCurrentAssetSelectionSetData(assetSelectionSet);
          self.notifyParameterValueChanged();
        });
      });

      // Set initial parameter value text.
      if (this.currentAssetSelectionSet) {
        this._setCurrentAssetSelectionSetData(this.currentAssetSelectionSet);
      }

      // Setup drop handler for Solovis reference.
      Solovis.Site.DragDropManager.setupSolovisRefDrop(this.container, function (solovisRef) {
        if (solovisRef.type == "assetSelectionSet") {
          self.setParameterValue(solovisRef.value);
        }
      });

      // Setup drag handler.
      Solovis.Reports.ReportLinker.setupSolovisRefLink(
        this.selectedAssetSelectionSetLabel,
        function () {
          var paramValue = AssetSelectionSetParameterControl.serializeParameterValue(self.getParameterValue());
          return { type: "assetSelectionSet", value: paramValue };
        });
    }


    public async _updateSelectionSetLabel() {
      //don't update label if new control
      if (this.options.renderMode === 'modern') {
        return;
      }
      if (this.currentAssetSelectionSet) {
        if (this.currentAssetSelectionSet.custom) {
          this.selectedAssetSelectionSetLabel.text("(Ad-Hoc) ");
        }
        else {
          this.selectedAssetSelectionSetLabel.text(this.currentAssetSelectionSet.name + " ");
        }
      }
      else {
        this.selectedAssetSelectionSetLabel.text("");
      }
    }

    public _setCurrentAssetSelectionSetData(assetSelectionSetData) {
      this.currentAssetSelectionSet = assetSelectionSetData;
      this._updateSelectionSetLabel();
    }

    public setParameterValue(newValue, more?) {
      Solovis.Reports.Parameters.ParameterControlHelper.handleSetParameterValue(
        this, AssetSelectionSetParameterControl, this._setCurrentAssetSelectionSetData, newValue, more);
    }

    public getParameterValue() {
      if (this.state < Solovis.UI.BaseControl.ControlState.afterInit) {
        return this.initialParameterValue ? this.initialParameterValue : null;
      }
      else if (this.currentAssetSelectionSet) {
        return Solovis.deepCopy(this.currentAssetSelectionSet);
      }
      else {
        return null;
      }
    }

    public notifyParameterValueChanged() {
      $(this).trigger("parameterValueChanged");
    }


    public _showSelectedSetContextMenu(e) {
      var self = this;

      if (this.currentAssetSelectionSet) {
        // NOTE: Do not use autoClickSingleItem here. It's not a good experience if someone is trying
        //   to click the edit link and ends up jumping to another page instead.

        var selectionSetToUse = AssetSelectionSetParameterControl.serializeParameterValue(self.getParameterValue());

        var links = [];

        var reportCodeForAssetSelectionSetContents = "EB5CC7CF-5599-4420-891A-6F67D91AD57B";

        var selectionSetContentsLink = Solovis.Reports.ReportLinker.getReportLink({
          reportCode: reportCodeForAssetSelectionSetContents,
          parameters: {
            assetSelectionSet: selectionSetToUse
          },
          autoRun: true
        });

        links.push({
          label: "Selection Set Contents",
          href: selectionSetContentsLink
        });

        links.push({ separator: true });

        if (selectionSetToUse.custom) {
          links.push({
            label: "Edit Ad-hoc Set",
            click: function () {
              self._showAdHocEditor(selectionSetToUse.custom);
            }
          })
        }
        else {
          links.push({
            label: "Edit As Ad-hoc Set",
            click: function () {
              self._convertToAdHoc(true);
            }
          })
        }

        links.push({
          label: "Combine With...",
          click: () => {
            let newSelectionSet = {
              custom: {
                mods: [
                  { op: "Add", set: this.currentAssetSelectionSet },
                  { op: "Intersect", set: null },
                ]
              }
            };

            //this.setParameterValue(newSelectionSet);
            self._showAdHocEditor(newSelectionSet.custom);
          }
        });

        Solovis.UI.PopupLinkPanel.showLinks({
          offset: { left: e.pageX, top: e.pageY },
          links: links
        });
      }
    }

    public _showAdHocEditor(adHocSelectionSet: any) {
      const self = this;

      if (adHocSelectionSet) {
        Solovis.ModuleLoader.modalEnsureModuleListLoaded(["Solovis.ValueEditors"], function () {
          // TODO: Replace with strongly typed referenced once ValueEditors is a typescript project.
          const editDialog = new (Solovis as any).Site.ValueEditors.AssetSelectionSets.SelectionSetEditorDialog({
            container: self.container[0],
            assetSelectionSetData: adHocSelectionSet,
            saveCallback: async function (savedSelectionSetInfo) {
              let newParamValue;
              if (savedSelectionSetInfo.assetSelectionSetId) {
                newParamValue = { id: savedSelectionSetInfo.assetSelectionSetId };
              }
              else {
                newParamValue = {
                  custom: savedSelectionSetInfo.selectionSetData
                };
              }

              if (self.options.renderMode === 'modern') {
                //set input text to ad-hoc
                self.selectRef.setValue({
                  name: "(Ad-Hoc) ",
                  custom: newParamValue.custom,
                });
              } else {
                self.setParameterValue(newParamValue);
              }
            }
          });
          editDialog.show();
        });
      }
    }

    public _convertToAdHoc(showEditor?: boolean) {
      var self = this;

      if (this.currentAssetSelectionSet && this.currentAssetSelectionSet.id) {
        this._portalServices.reportDataLoader().loadDataSetAsync(
          "/Solovis/Metadata/AssetSelectionSetList",
          { assetSelectionSetIds: [this.currentAssetSelectionSet.id], includeData: true },
          function (response, success) {
            if (success) {
              var dataSet = response.result.dataSet;
              var assetSelectionSetInfo: any = _.find(dataSet.assetSelectionSets, function (i: any) { return i.id == self.currentAssetSelectionSet.id; })
              if (assetSelectionSetInfo) {
                var newAssetSelectionData = assetSelectionSetInfo.assetSelectionSetData ? assetSelectionSetInfo.assetSelectionSetData : { blocks: [] };
                var newParamValue = {
                  custom: newAssetSelectionData
                };

                if (showEditor) {
                  self._showAdHocEditor(newAssetSelectionData);
                } else {
                  self.setParameterValue(newParamValue);
                }
              }
              else {
                Solovis.UI.alert("Unable to find asset selection set for id: " + self.currentAssetSelectionSet.id);
              }
            }
          },
          {
            invokeMethod: "invokeAndWait"
          });
      }
    }


    // In the Classic UI only, this displays the Select Asset Selection Set Dialog.
    public _toggleSelectorDialog(selectionCallback) {
      var self = this;

      let customValue;
      if (self.currentAssetSelectionSet && self.currentAssetSelectionSet.custom) {
        // We'll reuse the custom value so you don't lose your query when re-selecting (Ad-hoc).
        customValue = self.currentAssetSelectionSet.custom;
      } else {
        customValue = AssetSelectionSetParameterControl.getDefaultSelectionSet();
      }

      this._portalServices.reportDataLoader().loadDataSetAsync(
        "/Solovis/Metadata/AssetSelectionSetList",
        {},
        function (response) {
          let options = [];

          // Note: For the New UI, Ad-hoc dialog, these parameter names were changed. Label is changed to "name" and "entry" is removed from around "custom".
          options.push({ label: "(Ad-hoc)", entry: { custom: customValue } });

          $(response.result.dataSet.assetSelectionSets).each(function (i, set: any) {
            let option = {
              id: set.id,
              label: set.name,
              entry: set
            };

            if (set.category) {
              option.label = option.label + " (" + set.category + ")";
            }

            options.push(option);
          });

          let dialog = new Solovis.UI.Dialogs.StringFilterListDialog({
            stringFilterListControlOptions: {
              listItems: options
            },

            title: "Select Asset Selection Set",
            showClearButton: true,

            selectCallback: function (item) {
              if (item && item.entry && item.entry.custom) {
                self._showAdHocEditor(item.entry.custom);
              } else {
                self.setParameterValue(item ? item.entry : null);
              }
            }
          });
        },
        {
          invokeMethod: "invokeAndWait"
        });
    };
  }
}
